<template>
    <div>
        <page-header
            :title="title"
            :breadcrumbs="breadcrumbs"
            back-route="/media"
        />

        <div v-if="isFetching" class="card">
            <div class="card-body d-flex justify-content-center">
                <span class="spinner" style="width: 30px; height: 30px" />
            </div>
        </div>

        <div v-else class="card">
            <div class="card-body">
                <div class="form-group col-12">
                    <b-form-checkbox v-model="keepRatio" switch>
                        Keep Ratio
                    </b-form-checkbox>
                </div>
                <cropper
                    :src="imgSrc"
                    :canvas="false"
                    :stencil-props="stencilProps"
                    @change="onChange"
                />
                <div class="info d-flex mt-3">
                    <div class="original">
                        <div>
                            <strong>Original width:</strong>
                            {{ width }}
                        </div>
                        <div>
                            <strong>Original height</strong>:
                            {{ height }}
                        </div>
                    </div>
                    <div class="new ml-3">
                        <div>
                            <strong>Selected width:</strong>
                            {{ coordinates.width }}
                        </div>
                        <div>
                            <strong>Selected height</strong>:
                            {{ coordinates.height }}
                        </div>
                    </div>
                </div>
                <button class="btn btn-success mt-3" @click="crop">
                    Crop
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import { mediaUrl } from '@/config';

export default {
    page: {
        title: 'Crop Media'
    },

    components: {
        Cropper
    },

    data() {
        return {
            title: 'Crop Media',
            breadcrumbs: [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Media',
                    to: '/media'
                },
                {
                    text: 'Crop',
                    active: true
                }
            ],
            id: null,
            imgSrc: null,
            isFetching: true,
            coordinates: {},
            keepRatio: false,
            width: 0,
            height: 0
        };
    },

    computed: {
        stencilProps() {
            if (!this.keepRatio || !this.width || !this.height) {
                return {};
            }

            return {
                aspectRatio: this.width / this.height
            };
        }
    },

    watch: {
        isFetching: {
            async handler(val) {
                if (!val) {
                    await this.$nextTick();

                    const images = document.querySelectorAll('.card-body img');

                    images.forEach(image => {
                        image.removeAttribute('crossOrigin');
                    });
                }
            }
        }
    },

    created() {
        this.id = this.$route.params.id;
        this.getMedia();
    },

    methods: {
        ...mapActions({
            getSingleMedia: 'media/show',
            cropMedia: 'media/crop'
        }),

        async getMedia() {
            try {
                const {
                    filename,
                    date,
                    extension,
                    meta: { width, height }
                } = await this.getSingleMedia(this.id);

                this.width = width;
                this.height = height;

                this.imgSrc = `${mediaUrl}/images/${date}/${filename}.${extension}`;
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }

            this.isFetching = false;
        },

        onChange({ coordinates }) {
            this.coordinates = { ...coordinates };
        },

        async crop() {
            if (
                !this.coordinates.height &&
                !this.coordinates.width &&
                !this.coordinates.left &&
                !this.coordinates.top
            ) {
                this.$toaster('Please select an area.', { variant: 'info' });

                return;
            }

            this.isFetching = true;

            try {
                await this.cropMedia({
                    id: this.id,
                    coordinates: this.coordinates
                });

                this.$toaster('Image cropped!');
                this.$router.push('/media');
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }

            this.isFetching = false;
        }
    }
};
</script>
